import { Component, OnInit } from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';

@Component({
    standalone: false,
    selector: 'app-email-blast-detail-dialog-def-editor',
  templateUrl: './email-blast-detail-dialog-def-editor.component.html',
  styleUrls: ['./email-blast-detail-dialog-def-editor.component.scss']
})
export class EmailBlastDetailDialogDefEditorComponent extends DialogDefinitionEditorBase implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
